import { Visibility, VisibilityOff } from '@mui/icons-material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { IconButton, InputAdornment } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { useLogin } from './useLogin';

export const Login = () => {
  const {
    errors,
    onSubmit,
    register,
    isPasswordVisible,
    toggleIsPasswordVisible,
  } = useLogin();

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Se connecter
        </Typography>
        <Box sx={{ mt: 1 }}>
          <form onSubmit={onSubmit}>
            <TextField
              margin="normal"
              fullWidth
              id="email"
              label="Adresse email"
              autoComplete="email"
              autoFocus
              type="email"
              {...register('email')}
              helperText={
                errors.email?.message ? (
                  <Typography component="p" variant="body2" color="error.main">
                    {errors.email.message}
                  </Typography>
                ) : null
              }
            />
            <TextField
              margin="normal"
              fullWidth
              label="Mot de passe"
              type={isPasswordVisible ? 'text' : 'password'}
              id="password"
              autoComplete="current-password"
              {...register('password')}
              helperText={
                errors.password?.message ? (
                  <Typography component="p" variant="body2" color="error.main">
                    {errors.password.message}
                  </Typography>
                ) : null
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Afficher/Masquer le mot de passe"
                      onClick={toggleIsPasswordVisible}
                      onMouseDown={toggleIsPasswordVisible}
                    >
                      {isPasswordVisible ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Me connecter
            </Button>
          </form>
          <Grid container>
            <Grid item xs>
              <Link href="/forgot-password" variant="body2">
                Mot de passe oublié ?
              </Link>
            </Grid>
            <Grid item>
              <Link href="/create-account" variant="body2">
                Pas de compte ? Inscris-toi
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};
